import AdminNew from './AdminNew'

export default AdminNew;